/* eslint-disable no-undef */
import flatpickr from "flatpickr";
import $ from "jquery";

const editAccount = () => {
  const init = () => {
    handleResetData();
    handleDeleteAcount();
    selectCountry();
    bornDate();
  };

  const handleResetData = () => {
    const el = {
      button: ".js-reset-data",
      form: "form.edit-account",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function (e) {
      e.preventDefault();

      const inputList = [
        "account_first_name",
        "account_last_name",
        "account_display_name",
        "account_email",
        "billing_phone",
        "billing_address_1",
        "billing_streetname",
        "billing_house_number",
      ];

      for (const i in inputList) {
        $(`#${inputList[i]}`).val("");
      }
    });
  };

  const handleDeleteAcount = () => {
    const el = {
      button: "#js-delete-account",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      const textConfirm = $(el.button).data("confirm-text");
      // console.log(textConfirm)
      const confirm = window.confirm(textConfirm);

      if (!confirm) return;
      $.ajax({
        type: "POST",
        dataType: "json",
        url: themeObj.ajaxUrl,
        data: {
          action: themeObj.deleteAccount.action,
          nonce: themeObj.deleteAccount.nonce,
        },
        success() {
          window.location.reload();
        },
      });
    });
  };

  const selectCountry = () => {
    const el = {
      strong:
        ".woocommerce-address-fields__field-wrapper .woocommerce-input-wrapper strong",
      fields: ".woocommerce-EditAccountForm #billing_country",
    };

    $(window).on("load", function () {
      $(el.fields).select2();
    });
    if ($(el.strong).length === 0) return;

    $(window).on("load", function () {
      $(el.strong).parent().parent().addClass("has-no-country__lists");
    });
  };

  const bornDate = () => {
    const el = {
      born: "#billing_born_date",
    };

    if ($(el.born).length === 0) return;

    $(window).on("load", function () {
      flatpickr(el.born, {
        dateFormat: "d-m-Y",
        disableMobile: true,
        altInput: true,
        altFormat: "d-m-Y",
        allowInput: true,
        onReady: function () {
          // Add an input event listener to validate the entered date
          document
            .getElementById("billing_born_date")
            .addEventListener("input", function (event) {
              const input = event.target;
              const value = input.value;

              // Use a regular expression to match the "d-m-Y" format
              const validFormat = /^(\d{1,2})-(\d{1,2})-(\d{4})$/.test(value);

              if (!validFormat) {
                // If the input doesn't match the format, clear the input
                input.value = "";
              }
            });
        },
        parseDate: (datestr) => {
          return new Date(
            datestr.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")
          );
        },
      });
    });
  };

  init();
};

try {
  editAccount();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("edit-account.js: ", error);
}
